import { Recipient } from '../types/Recipient';

export const getUniqueRecipientsByEmail = (
  recipients: Recipient[]
): Recipient[] => {
  const seen = new Set<string>();
  return recipients.filter((recipient) => {
    const email = recipient.email ? recipient.email.toLowerCase() : '';
    if (seen.has(email)) return false;
    seen.add(email);
    return true;
  });
};
